module.exports = __webpack_public_path__ + "img/num5.f3f9ae8d.png";